import { useCallback } from 'react';

import { useGlobalsService } from '@restworld/data-services';

export const useShortenURL = () => {
  const globalServices = useGlobalsService();
  const getShortenURL = useCallback(
    async ({ longURL = '' }: { longURL?: string }) => {
      try {
        return (await globalServices.createShortenUrl({ original_url: longURL }))?.data?.data?.short_url ?? '';
      } catch (error) {
        console.error(`Error shortening the URL`, error);
        return 'error';
      }
    },
    [globalServices]
  );

  return { getShortenURL };
};
